
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BarChartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Investment_BarChart"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ru"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"point"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ru"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":145}};
    doc.loc.source = {"body":"fragment BarChartFragment on Investment_BarChart {\n  data {\n    value\n    title{\n      en\n      ru\n    }\n    point{\n      en\n      ru\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
